export default __webpack_public_path__ + "static/media/star-white.c4ec4ef7.svg";